// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"ace14d34","495":"ace14d34"}[chunkId] + ".chunk.css";
};